/**
 * 客户端版本号工具
 */
define('util/client-version',[],function() {
    var ua = navigator.userAgent.toLowerCase();
    // 获取客户端当前版本号
    var appVersion = (function() {
        if (CLIENT_DATA.client === 'ssj') {
            // 获取随手记客户端版本号
            var versionReg = /(mymoney|mymoneypro|mymoneyenterprise|mymoneyexpress)\/[\d.]+/gi;
            var version = ua.match(versionReg) ? ua.match(versionReg)[0].replace(/[^0-9.]/ig, '') : ''; // 有可能获取不到版本号
            // 如果老版本不能从ua获取到版本号，则尝试从window.FDMarketMetaNew或window.FDMarketMeta对象获取
            if (!version) {
                if (CLIENT_DATA.os === 'ios') {
                    version = window.FDMarketMetaNew ? window.FDMarketMetaNew.AppVersion : '';
                } else {
                    version = window.FDMarketMeta ? window.FDMarketMeta.AppVersion : '';
                }
            }
            return version;
        }
    })();
    /**
     * 版本号比较
     * featureVersion: 特性版本号
     * _currentVersion{String}: 当前版本号，如果不传，默认取客户端版本号
     * 说明：如果当前版本号大于或等于特性版本号，返回true，否则返回false
     */
    var compare = function(featureVersion, _currentVersion) {
        var currentVersion = _currentVersion || appVersion;
        try {
            // 无法获取正确的版本号
            if (!currentVersion) {
                return false;
            }
            // 版本号一致
            if (currentVersion === featureVersion) {
                return true;
            }
            // 逐位比较返回结果
            var currents = currentVersion.split('.');
            var targets = featureVersion.split('.');
            var length = currents.length > targets.length ? currents.length : targets.length;
            var currentSubVersion;
            var targetSubVersion;
            for (var i = 0; i < length; i++) {
                currentSubVersion = typeof (currents[i]) === 'undefined' ? 0 : currents[i];
                targetSubVersion = typeof (targets[i]) === 'undefined' ? 0 : targets[i];
                if (~~currentSubVersion > ~~targetSubVersion) {
                    return true;
                } else if (~~currentSubVersion < ~~targetSubVersion) {
                    return false;
                }
            }
        } catch (e) {
            // 错误情况下默认返回false
            return false;
        }
    };
    /**
     * 排序版本号
     * versions{String,Array}:需要排除的版本号
     * _currentVersion{String}: 当前版本号，如果不传，默认取客户端版本号
     * 说明：当前版本号在排除版本号中返回true，否则返回false
     */
    var splice = function(versions, _currentVersion) {
        var currentVersion = _currentVersion || appVersion;
        if (typeof versions === 'string') {
            if (currentVersion === versions) {
                return true;
            }
        } else if (versions instanceof Array) {
            var length = versions.length;
            for (var i = 0; i < length; i++) {
                if (currentVersion === versions[i]) {
                    return true;
                }
            }
            return false;
        } else {
            return false;
        }
    };

    return {
        compare: compare,
        splice: splice
    };
});

